import React, { useState } from 'react';
import toast from 'react-hot-toast';
import {
  DocumentArrowDownIcon,
  ArrowLeftIcon
} from '@heroicons/react/24/outline';
import { API_BASE } from '../../lib/config';

const DataExport = ({ onBack }) => {
  const [downloading, setDownloading] = useState(false);

  const fetchCSV = async (type) => {
    setDownloading(true);
    try {
      const token = localStorage.getItem('admin_token') || localStorage.getItem('token');
      // Call endpoints in routes_reports.py (e.g. /admin/users, /admin/jobs)
      // We assume these endpoints return JSON lists.
      const res = await fetch(`${API_BASE}/admin/${type}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        const csvContent = convertToCSV(data);
        downloadCSV(csvContent, `${type}_export_${new Date().toISOString().slice(0, 10)}.csv`);
        toast.success('エクスポートが完了しました');
      } else {
        toast.error('データの取得に失敗しました');
      }
    } catch (e) {
      console.error(e);
      toast.error('エクスポートエラー');
    } finally {
      setDownloading(false);
    }
  };

  const convertToCSV = (objArray) => {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    if (!array || array.length === 0) return '';

    const header = Object.keys(array[0]).join(',') + '\n';
    const rows = array.map(obj => {
      return Object.values(obj).map(val => {
        // Handle strings with commas, newlines, or double quotes
        let str = String(val === null || val === undefined ? '' : val);
        if (str.includes(',') || str.includes('\n') || str.includes('"')) {
          str = `"${str.replace(/"/g, '""')}"`;
        }
        return str;
      }).join(',');
    }).join('\n');

    return header + rows;
  };

  const downloadCSV = (csv, filename) => {
    // BOM for Excel compatibility
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([bom, csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className="space-y-6">
      {onBack && (
        <div className="flex items-center">
          <button onClick={onBack} className="flex items-center text-gray-600 hover:text-gray-900">
            <ArrowLeftIcon className="w-5 h-5 mr-2" />
            メニューに戻る
          </button>
        </div>
      )}

      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">データエクスポート</h2>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <p className="mb-4 text-gray-600">システムの各種データをCSV形式でダウンロードできます。</p>
        <div className="flex gap-4 flex-wrap">
          <button
            onClick={() => fetchCSV('users')}
            disabled={downloading}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50 flex items-center"
          >
            <DocumentArrowDownIcon className="w-5 h-5 mr-2" />
            ユーザーデータ (CSV)
          </button>
          <button
            onClick={() => fetchCSV('jobs')}
            disabled={downloading}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50 flex items-center"
          >
            <DocumentArrowDownIcon className="w-5 h-5 mr-2" />
            求人データ (CSV)
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataExport;